module.exports = __webpack_public_path__ + "img/edit.f9b7bb91.svg";